import React, { useEffect } from "react"
import clsx from "clsx"

import Container from "@ecom/ui/components/Container"
import Button from "@material-ui/core/Button"
import Img from "./Img"

import * as styles from "./banner.module.scss"
import { useObserver } from "../../../hooks/useObserver"
import {
  handleClickBanner,
  handleClickStickyBtn,
} from "../../../helpers/WatcherDL/utils/handleClickBanner"

const title = (
  <>
    Кредитная карта <br className="d-none d-sm-block d-md-none" /> без&nbsp;%
  </>
)

type BannerProps = {
  buttonText?: string
  orderNum?: string
}

export function Banner({ buttonText = "Оформить", orderNum }: BannerProps) {
  useEffect(() => {
    document.body.style.display = "block"
  }, [])

  const isVisible = useObserver(["formPkw"])

  return (
    <>
      <section className={styles.section} data-exclude={orderNum}>
        <Container className={styles.container}>
          <div className={clsx(styles.secondContainer)}>
            <Img alt="bg image" className={styles.img} />

            <div className={styles.text}>
              <h1>{title}</h1>
              <p>Бесплатное снятие наличных</p>
            </div>
            <Button className={styles.btn} onClick={() => handleClickBanner(buttonText, title)}>
              {buttonText}
            </Button>
          </div>
        </Container>
      </section>
      <div className={clsx(styles.btnBlock, { [styles.hideMobBlock]: isVisible })}>
        <Container>
          <Button onClick={handleClickStickyBtn} className={styles.mobBtn}>
            {buttonText}
          </Button>
        </Container>
      </div>
    </>
  )
}
